








import { Component, Vue } from 'vue-property-decorator';

@Component({
    name: 'PmToDoWizard',
    components: {},
})
export default class PmToDoWizard extends Vue {
    private next() {
        this.$router.push({
            name: 'PmToDosList',
            query: {
                referrer: 'projects',
            },
        });
    }
}
